import { makeStyles, createStyles } from '@material-ui/core'

export const useConfirmCloseApplicantModalStyles = makeStyles((theme) =>
  createStyles({
    closeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1)
    },

    buttons: {
      display: 'flex',
      width: '60%',
      justifyContent: 'space-between',
      margin: 'auto',
      marginBottom: '24px',
      marginTop: '15px',

      '& > button:last-child': {
        marginLeft: 20
      }
    },

    title: {
      fontFamily: 'Roboto',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.25px'
    },

    closeButton: {
      height: '38px',
      width: '94px',
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      background: '#E52428'
    },

    cancelButton: {
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: '#2E86BD'
    },

    f: {
      maxWidth: '469px'
    }
  })
)
